import server from '../../api/server';
const state = {
    ref : null,
    password : null
};
const getters = {

}
const actions = {
    async findSinister({commit}, data){
        console.log(data);
        commit('UPDATE_REF', data.ref);
        commit('UPDATE_PASSWORD', data.password);
        return new Promise((resolve, reject) => {
            server.post('/sinister/auth', data)
            .then((res) =>{
                console.log(res);
                localStorage.setItem('jwt', res.data);
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            })
        });
    }
};
const mutations = {
    UPDATE_REF(state,data){
        state.ref = data;
    },
    UPDATE_PASSWORD(state,data){
        state.password = data;
    }
};

export default{
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}